const r=[2,3,4,5,6,8,12,16,24,48];export{r as PriceArrayKeys};